import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

const ScrollToTopPage = ({ location, withDelay }) => {
  useEffect(() => {
    if (withDelay) {
      debounce(() => {
        window.scrollTo(0, 0);
      }, 50)();
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, withDelay]);

  return null;
};

ScrollToTopPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  withDelay: PropTypes.bool,
};

ScrollToTopPage.defaultProps = {
  withDelay: false,
};

export default withRouter(ScrollToTopPage);
